import { BACKGROUND_IMAGE_DESKTOP, BACKGROUND_IMAGE_MOBILE } from '../elements/assets'
import { BUTTON, BUTTON_SETTINGS } from '../elements/link'

export const CTA_CONTENT = `
id
typeHandle

ctaContent {
  ... on ctaContent_Entry {
    id
    backgroundColor
    ${ BACKGROUND_IMAGE_DESKTOP }
    ${ BACKGROUND_IMAGE_MOBILE }
    heading {
      html
      plainText
    }
    description
    ${ BUTTON }
    ${ BUTTON_SETTINGS }
    popupEnabled
    popupFormId
    buttonColor
  }
}
`

export const CTA = `
...on cta_Entry {
  ${ CTA_CONTENT }
}
`

export const CTA_CONTAINED = `
...on ctaContained_Entry {
  anchorId
  ${ CTA_CONTENT }
}
`

export const CTA_COMPACT = `
...on ctaCompact_Entry {
  ${ CTA_CONTENT }
}
`

export const CTA_BACKGROUND_IMAGE = `
...on ctaBackgroundImage_Entry {
  ${ CTA_CONTENT }
}
`